
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Shield, Clock, DollarSign, Calendar, Scan } from "lucide-react";
import { Link } from "react-router-dom";

const Security = () => {
  const upcomingShifts = [
    {
      id: 1,
      venue: "The Grand Nightclub",
      date: "Tonight",
      time: "10:00 PM - 4:00 AM",
      rate: "$35/hr",
      status: "Confirmed"
    },
    {
      id: 2,
      venue: "Sky Lounge",
      date: "Tomorrow",
      time: "9:00 PM - 3:00 AM",
      rate: "$40/hr",
      status: "Pending"
    }
  ];

  const features = [
    {
      icon: Shield,
      title: "Verified Venues",
      description: "Work at pre-screened, legitimate venues"
    },
    {
      icon: Clock,
      title: "Flexible Hours",
      description: "Choose shifts that fit your schedule"
    },
    {
      icon: DollarSign,
      title: "Competitive Pay",
      description: "Earn competitive hourly rates plus bonuses"
    },
    {
      icon: Calendar,
      title: "Regular Work",
      description: "Build relationships with venues for consistent shifts"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-24 pb-32">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Security Staff Portal
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Find security shifts at top venues and manage your work schedule
          </p>
          <div className="mt-8">
            <Button asChild className="bg-purple-600 hover:bg-purple-700 mb-4">
              <Link to="/security/check-in">
                <Scan className="mr-2 h-5 w-5" />
                Try ID Verification & Check-In Demo
              </Link>
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {features.map((feature, index) => (
            <Card key={index} className="p-6 bg-gray-900/50 border-gray-800">
              <feature.icon className="w-12 h-12 text-purple-400 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
              <p className="text-gray-400">{feature.description}</p>
            </Card>
          ))}
        </div>

        <Card className="bg-gray-900/50 border-gray-800 p-6 mb-16">
          <h2 className="text-2xl font-semibold text-white mb-6">Upcoming Shifts</h2>
          <div className="space-y-4">
            {upcomingShifts.map((shift) => (
              <Card key={shift.id} className="p-4 bg-gray-800/50 border-gray-700">
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="font-semibold text-white">{shift.venue}</h3>
                    <p className="text-gray-400">{shift.date} • {shift.time}</p>
                  </div>
                  <div className="text-right">
                    <Badge 
                      variant={shift.status === "Confirmed" ? "default" : "secondary"}
                      className="mb-2"
                    >
                      {shift.status}
                    </Badge>
                    <p className="text-purple-400 font-semibold">{shift.rate}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </Card>

        <div className="text-center">
          <Button asChild size="lg" className="bg-purple-600 hover:bg-purple-700">
            <Link to="/auth">Sign Up as Security Staff</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Security;
